// client/src/pages/doctors/FormTemplates.jsx
import React from 'react';
import FormList from '../../components/doctors/FormBuilder/FormList';

const FormTemplates = () => {
  return <FormList />;
};

export default FormTemplates;